import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { BaseState } from '@base/entities/BaseEntities';
import { BaseComponent } from '@base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { EnumFileBoxReturnDataTypes } from '@core/framework/sysenums.enum';
import { Utils } from '@core/helpers/Utils';


@Component({
    providers: ServiceBagServices,
    selector: 'm4u-fileboxdialog',
    templateUrl: './fileboxdialog.component.html',
    styleUrls: ['./fileboxdialog.component.scss']
})
export class FileBoxDialogComponent extends BaseComponent<BaseState>
{
    @ViewChild('fileLoader') fileLoader: ElementRef;
    @Input() ReturnDataType: EnumFileBoxReturnDataTypes;
    @Input() IsAllowMultiple: boolean;
    @Input() AllowedFileTypes: string;

    constructor(A: ServiceBagService)
    {
        super(A, 'FileBoxDialogComponent', BaseState);
    }

    private handler: (e: any) => void;
    public ShowDialog(DialogCompletedHandler: (e: any) => void)
    {
        //Show the dialog
        this.handler = DialogCompletedHandler;
        this.fileLoader.nativeElement.click();
    }

    OnFileSelected()
    {
        //Get list of files selected
        var list: FileList = this.fileLoader.nativeElement.files;
        if (list == undefined || list.length == 0) return;

       


        //Return raw FileList
        if (this.ReturnDataType == EnumFileBoxReturnDataTypes.FileList)
        {
            this.handler(list);
            this.ResetInput();
            return;
        }


        //Read the file
        var reader = new FileReader();
        reader.onloadend = (e) =>
        {
            //Get data
            var data: string = (e.srcElement as any).result;

            //Reset value on input, so that next time change event is triggered again
            this.fileLoader.nativeElement.value = null;

            //Execute callback
            switch (this.ReturnDataType)
            {
                case EnumFileBoxReturnDataTypes.FileDataAsString:
                    //Return as plain data
                    this.handler(data);

                case EnumFileBoxReturnDataTypes.FileDataAsLinesArray:
                    //Return as lines array
                    var arrLines = data.split(/\r?\n/);
                    arrLines = arrLines.filter(x => !Utils.IsEmpty(x));
                    this.handler(arrLines);
                    return;

                case EnumFileBoxReturnDataTypes.FileDataAsJSONArray:
                    //Return as JSON
                    //Return as lines array
                    var arrObjects = Utils.ConvertCSVToJSONArray(data, ",");
                    this.handler(arrObjects);
                    return;

            }
        }
        reader.readAsText(list[0]);
        this.ResetInput();
    }

    private ResetInput() {
        this.fileLoader.nativeElement.value = "";
    }


}
